// RCA 1 (New-lead-table load perf): the contact-attempts counter fan-out
// (NHS / No-Treatment / Awaiting / 4x NEW_TAB_HEAD — 7 /leads/ count dispatches, fired
// by NewLeadTable.jsx's `reloadCounter`) backs badges that only render in
// Contact-attempts mode. In Tasks mode the fan-out is pure waste on every load,
// filter, search and pagination change.
//
// This predicate is a standalone module (not folded into taskModeQuery.js, which sits
// next to it) specifically to keep it out of a file that already carries a
// pre-existing, out-of-scope lint error — see task-1-report.md "Concerns" for the
// pre-commit hook context. Kept pure and tiny on purpose: NewLead.jsx's
// wrappedReloadCounter calls this instead of inlining the condition so the gate's
// POLARITY has a real, directly-exercised unit test. A source-scan test can confirm
// the right tokens/call are present in NewLead.jsx but cannot tell `if (x) return`
// from an inverted `if (!x) return` — an inverted predicate would silently flip the
// whole feature (skip in Contacts mode, fire in Tasks mode) and still read as
// "gated". See tests/unit/utils/shouldSkipCounterReload.test.js.

/**
 * @param {boolean} tasksMode  live tasks-mode flag (pass newLeadTasksModeRef.current at
 *                              the call site, not the possibly-stale state value, so a
 *                              stale effect closure can't leak a wrong mode)
 * @returns {boolean} true when the counter reload should be SKIPPED (Tasks mode)
 */
export function shouldSkipCounterReload(tasksMode) {
    return !!tasksMode;
}
